import { BlinqLogo } from '@components/BlinqAssets';

import { BlinqLogoStyle } from './Logo.css';

export const Logo = (): JSX.Element => <BlinqLogo className={BlinqLogoStyle} />;
